import * as React from 'react';
import type { SVGProps } from 'react';
const SvgComputer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#4B7EFF" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.4}
      d="M46 20.916A20 20 0 0 0 40 20c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20c0-3.43-.864-6.66-2.386-9.481M50 27.5h.01M37 59.777V55.37a1 1 0 0 1 .241-.65l4.972-5.801a1 1 0 0 0-.264-1.52l-5.712-3.264a1 1 0 0 1-.372-.372l-3.724-6.526a1 1 0 0 0-.957-.5l-11.056.984M58 28c0 4.418-4 8-8 12-4-4-8-7.582-8-12a8 8 0 1 1 16 0m-7.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);
export default SvgComputer;
